import React from "react";
import portrait from "./images/image-standin.png";

export default class TemplateR extends React.Component {
    constructor () {
        super();
    }

    render() {
        return (
            <main className="project-container">
                <div className="project-wrapper">
                    <div className="project-image">
                        <img src={portrait} width="350px"  alt="Self Portrait"></img>
                    </div>
                    <div className="project-description">
                        <p1>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus varius tellus ac risus lobortis, eget pretium nunc porta. Nunc vitae turpis vehicula, hendrerit magna at, sodales elit. Praesent feugiat placerat aliquam. Nullam ut purus eget diam cursus eleifend. Integer risus nulla, suscipit eu elit sodales, convallis facilisis leo. Morbi ac tortor id nibh aliquet sollicitudin sit amet eu eros. Aliquam vulputate enim sapien, a condimentum nunc malesuada eget. Aliquam quis augue sem. Maecenas quis ex ut arcu finibus vehicula vitae ut sapien. Nam congue, quam id commodo mollis, velit ipsum mattis eros, ac fermentum ligula odio et leo. Nunc nec arcu ut elit aliquet venenatis vitae ac tortor.</p1>
                    </div>
                </div>
            </main>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/projects/TemplateR.js